<div class="col-lg-12 selected-pages p-2 float-left">
  <ul class="p-0 m-0">
    <li *ngFor="let crumb of crumbs$ | async">
      <a class="font-text-bold" [routerLink]="crumb.link" [innerHTML]="crumb.label"></a>
    </li>
  </ul>
</div>
